import React from 'react';

import { observer } from 'mobx-react';

import withDisplayName from 'bz-utilities/hoc/display-name';

import type {
  CustomerPackagesResponse,
  CustomerSubscriptionResponse,
  PackageBundleResponse
} from 'tm3-core/api.dtos';

const Bundle = React.lazy(() => import('../bundle'));

interface IProps {
  pkg: CustomerPackagesResponse | CustomerSubscriptionResponse;
}

const PackageBundles = observer(
  withDisplayName<IProps>((props) => {
    const { bundles } = props.pkg;

    const content = bundles.map((bundle: PackageBundleResponse, i: number) => {
      return <Bundle key={i} bundle={bundle} />;
    });

    return <>{content}</>;
  }, 'PackageBundles')
);

export default PackageBundles;
